<div *ngIf="menuOpen"
     (click)="closeMenu(true, $event)"
     class="fixed inset-0 z-[990] opacity-0">
</div>

<div class="inset-0 z-[999] h-full transition-all">
    <div class="relative">

        <ng-content select="[dropdown-button]"></ng-content>

        <div class="profile-menu-dropdown
                    absolute top-full z-[995] w-max origin-top-right
                    bg-white dark:bg-black
                    rounded-xl border border-secondary-100/[0.30] dark:border-secondary-100/[0.25]
                    shadow-md transition-all duration-150 ease-in-out"
             [class.invisible]="!menuOpen" [class.opacity-0]="!menuOpen"
             [class.scale-95]="!menuOpen"
             [class.-translate-y-2]="!menuOpen" [class.opacity-100]="menuOpen"
             [class.scale-100]="menuOpen"
             [class.translate-y-0]="menuOpen"
             [ngStyle]="menuStyles"
             (click)="onDropdownContentClick($event)">

            <ng-content select="[dropdown-content]"></ng-content>

        </div>
    </div>
</div>
